<app-header></app-header>
<main class="content">
  <router-outlet />
</main>
<app-footer></app-footer>
